import { useMemo } from 'react';

import { useTranslate } from '@i18n';
import { useCategories, useUiParameters } from '@queries';
import { typography } from '@ui';

import { NewParameter } from '../NewParameter/NewParameter';

import * as css from './CustomModuleEditor.css';

const P_POSITION_REGEX = /p\d{1,2}$/;
type ParameterGroupsProps = {
    groupId: string;
    selectedParameterIds: string[];
    onSelect: (parameterId: string) => void;
    activityId: number;
    activeSwingId?: string;
};
export const ParameterGroups = ({
    groupId,
    selectedParameterIds,
    onSelect,
    activityId,
    activeSwingId,
}: ParameterGroupsProps) => {
    const { data: parameters = [] } = useUiParameters();
    const { data: swingFoundationGroups = [] } = useCategories('swing_foundation_group');

    const position = groupId.match(P_POSITION_REGEX)?.[0];
    const filteredSwingFoundationGroups = useMemo(
        () => swingFoundationGroups.filter((group) => position && group.id.includes(position)),
        [position, swingFoundationGroups],
    );

    const parameterGroupsMap = useMemo(() => {
        return Object.fromEntries(
            filteredSwingFoundationGroups.map((group) => [
                group.id,
                parameters.filter((parameter) => parameter.categories.swingFoundationGroup === group.id),
            ]),
        );
    }, [filteredSwingFoundationGroups, parameters]);

    const t = useTranslate();

    return filteredSwingFoundationGroups.map((group) => (
        <div className={css.group} key={group?.id || 'other'}>
            <h4 className={typography({ variant: 'h3' })}>{t(group?.i18n || 'Other')}</h4>
            <div className={css.parameters}>
                {parameterGroupsMap[group.id]?.map((parameter) => (
                    <NewParameter
                        key={parameter.id}
                        node={parameter}
                        isSelected={selectedParameterIds.includes(parameter.id)}
                        onClick={() => onSelect(parameter.id)}
                        activityId={activityId}
                        activeSwingId={activeSwingId}
                    />
                ))}
            </div>
        </div>
    ));
};
